import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { pluck } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class StorageService {

  constructor(
    private readonly http: HttpClient, 
    private readonly toastService: ToastrService, 
    private readonly translateService: TranslateService
  ){}

  public baseURL = environment.serverApiBaseUrl;

  public getItem(key: string): any {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch {
      this.removeItem(key);

      return null;
    }
  }

  public getTableState(key: string): { columns: any; filter: any; page: any; sort: any } {
    return this.getItem(key);
  }

  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  public clearAll() {
    localStorage.clear();
  }

  public setItem(key: string, value: any): boolean {
    try {
      localStorage.setItem(key, JSON.stringify(value));

      return true;
    } catch {
      return false;
    }
  }

  public setTableState(key: string, filter: any, sort: any, page: any, columns: any): void {
    columns.map(col => {
      col.value ? null : col.value = col.label; 
    })
    const tableState = { filter, sort, page, columns };

    this.setItem(key, tableState);
  }

  //TODO: totaly temporary, we need move this for bundle service
  public updateProductStatus(Id, productId, status, from){
    const url = `/${this.baseURL}/${from}/${Id}/products/${productId}`;
    const body = {
      inactiveProduct: status
    };
    this.toastService.success(this.translateService.instant('generic.generic_success_title'));
    return this.http.patch(url, body);
  }

  //TODO: totaly temporary, we need move this for bundle service
  public removeCoexistenceProduct(bundleId, offerId){
    const url = `/${this.baseURL}/bundle/delete/exclusionOffers`;
    const body = {
      bundleId: bundleId,
      offersId: [offerId]
    };
    this.toastService.success(this.translateService.instant('generic.generic_success_title'));
    return this.http.post(url, body);
  }

  public checkFeatureFlag(flag: string) {
    let ff = this.getItem("feature-flag");

    if (!ff) return false;

    try {
      if (typeof ff === "string") {
        ff = ff.replace(/([{,]\s*)([A-Za-z0-9_]+)\s*:/g, '$1"$2":');

        
        ff = JSON.parse(ff);
      }

      return ff?.[flag] ?? false;

    } catch (error) {
      console.error("Erro ao ler feature-flag:", error);
      return false;
    }
  }

  public getFeatureFlag() {
    const url = `/venus-api/offer/featureFlag`;// this need refactor, move to out offer because should be generic
    return this.http.get(url);
  }
}
